import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import TableHead from "@material-ui/core/TableHead";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(0),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage } = props;

  const handleFirstPageButtonClick = (event) => {
    onChangePage(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

function createData(name, calories, fat) {
  return { name, calories, fat };
}

// const rows = [
//   createData("Cupcake", 305, 3.7),
//   createData("Donut", 452, 25.0),
//   createData("Eclair", 262, 16.0),
//   createData("Frozen yoghurt", 159, 6.0),
//   createData("Gingerbread", 356, 16.0),
//   createData("Honeycomb", 408, 3.2),
//   createData("Ice cream sandwich", 237, 9.0),
//   createData("Jelly Bean", 375, 0.0),
//   createData("KitKat", 518, 26.0),
//   createData("Lollipop", 392, 0.2),
//   createData("Marshmallow", 318, 0),
//   createData("Nougat", 360, 19.0),
//   createData("Oreo", 437, 18.0),
// ].sort((a, b) => (a.calories < b.calories ? -1 : 1));

const useStyles2 = makeStyles({
  table: {
    minWidth: "100%",
  },
  toobarBgColor: {
    "& .MuiToolbar-regular": {
      background: "#fff",
    },
  },
  container: {
    maxHeight: "218px",
    minHeight: "266px",
    overflowY: "hidden",
    "&:hover": {
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "4px",
      },

      /* Track */

      "&::-webkit-scrollbar-track": {
        background: "#fff",
      },

      /* Handle */

      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#d4d8da",
        borderRadius: "20px",
        // border: "3px solid orange",
      },

      /* Handle on hover */

      "&::-webkit-scrollbar-thumb:hover": {
        background: "",
      },
    },
  },
});
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

export default function InvoicesDashboardTable(props) {
  const classes = useStyles2();
  const [page, setPage] = React.useState(0);
  // let array = [{ invoicedate: "1", count: "1" }];
  const [array, setArray] = React.useState([
    { invoicedate: "No Data", count: "No Data" },
  ]);

  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  useEffect(() => {
    let getValue = props.allInvoices;
    //console.log(array, props.allInvoices, "aaaaaaaaaaa");
    if (props.allInvoices.length > 0) {
        
      setArray(props.allInvoices);
    } else {
      setArray([{ invoiceCount: 'No Data', date: 'No Data', soCount: 'No Data' }]);
    }

    // setArray(props.allInvoices);
  }, [props]);
  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, array.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div>
      <TableContainer component={Paper} className={classes.container}>
        <Table
          className={classes.table}
          aria-label="simple table"
          stickyHeader
          aria-label="sticky table"
        >
          <TableHead>
            <TableRow>
              <StyledTableCell>
                <b>Date</b>
              </StyledTableCell>
              <StyledTableCell align="right">
                <b>No of Invoices</b>
              </StyledTableCell>
              <StyledTableCell align="right">
                <b>No of Sales Orders</b>
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? array.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
              )
              : array
            ).map((row) => (
              <TableRow>
                <TableCell component="th" scope="row">
                  <b>{row.date}</b>
                </TableCell>
                <TableCell align="right">
                  <div>
                    {
                      row.invoice ? (
                        <b>{row.invoice}</b>
                      ) : (
                        <b>0</b>
                      )
                    }

                  </div>
                </TableCell>
                <TableCell align="right">
                  <div>
                    {
                      row.created ? (
                        <b>{row.created}</b>
                      ) : (
                        <b>0</b>
                      )
                    }

                  </div>

                </TableCell>
                {/* <TableCell align="right">{0}</TableCell> */}
              </TableRow>
            ))}

            {/* {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )} */}
          </TableBody>
          <TableFooter>
            <TableRow></TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
      <TableContainer>
        <TablePagination
          className={classes.toobarBgColor}
          rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
          component="div"
          count={array.length}
          rowsPerPage={rowsPerPage}
          page={page}
          SelectProps={{
            inputProps: { "aria-label": "rows per page" },
            native: true,
          }}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
        />
      </TableContainer>
    </div>
  );
}
